export { default } from './Carousel';